<template>
    <v-container>
    <div>
        <div class="d-flex align-center my-4">
        <div class="text-h6 font-weight-bold text-left">系所管理</div>
        <v-divider class="flex-grow-1 ml-2"></v-divider>
        <v-btn
          color="black"
          dark
          @click="addDepartmentDialog = true"
        >
          新增系所
        </v-btn>
        </div>
        
        <v-simple-table>
        <template v-slot:default>
            <thead>
            <tr>
                <th>系所名稱</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="department in departments" :key="department.id">
                <td class="text-left">{{ department.name }}</td>
                <td class="text-right">
                <v-icon
                    small
                    class="mr-2"
                    @click="editDepartment(department)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteDepartment(department)"
                >
                    mdi-delete
                </v-icon>
                </td>
            </tr>
            </tbody>
        </template>
        </v-simple-table>
  </div>
  <v-dialog v-model="addDepartmentDialog" max-width="1000px" rounded="lg">
    <v-card class="pa-6">
      <v-card-title class="text-h5 mb-4 text-left">
        新增系所
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="departmentName" label="系所名稱" outlined></v-text-field>
      </v-card-text>
      <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="grey" text height="44" @click="addDepartmentDialog = false"
            style="border-radius: 10px;width: 15rem;">
            關閉
        </v-btn>
        <v-btn color="black" dark height="44" @click="addDepartment"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="editDepartmentDialog" max-width="1000px" rounded="lg">
    <v-card class="pa-6" v-if="editingDepartment">
      <v-card-title class="text-h5 mb-4 text-left">
        修改系所
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="editingDepartment.name" label="系所名稱" outlined></v-text-field>
      </v-card-text>
      <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="grey" text height="44" @click="editDepartmentDialog = false"
            style="border-radius: 10px;width: 15rem;">
            關閉
        </v-btn>
        <v-btn color="black" dark height="44" @click="updateDepartment"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="deleteConfirmDialog" max-width="500px">
    <v-card v-if="deletingDepartment">
      <v-card-title class="text-h5">確認刪除</v-card-title>
      <v-card-text>
        確定要刪除「{{ deletingDepartment.name }}」系所嗎？此操作無法復原。
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancelDelete">取消</v-btn>
        <v-btn color="red darken-1" text @click="confirmDelete">確認刪除</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>
<script>
import { DepartmentApiService } from '../../services/department.service';

export default {
    name: 'schoolDepartment',
    data() {
        return {
            addDepartmentDialog: false,
            editDepartmentDialog: false,
            deleteConfirmDialog: false,
            departmentName: '',
            departments: [],
            editingDepartment: null,
            deletingDepartment: null
        }
    },
    async created() {
        await this.fetchDepartments();
    },
    methods: {
        async fetchDepartments() {
            try {
                this.departments = await DepartmentApiService.getDepartmentsBySchool();
            } catch (error) {
                console.error('獲取系所列表失敗:', error);
                // 可以添加錯誤提示
            }
        },
        async addDepartment() {
            try {
                await DepartmentApiService.createDepartment({ name: this.departmentName });
                await this.fetchDepartments();
                this.departmentName = '';
                this.addDepartmentDialog = false;
            } catch (error) {
                console.error('新增系所失敗:', error);
                // 可以添加錯誤提示
            }
        },
        editDepartment(department) {
            this.editingDepartment = { ...department };
            this.editDepartmentDialog = true;
        },
        async updateDepartment() {
            try {
                await DepartmentApiService.updateDepartment(
                    this.editingDepartment._id,
                    { name: this.editingDepartment.name }
                );
                await this.fetchDepartments();
                this.editDepartmentDialog = false;
                this.editingDepartment = null;
            } catch (error) {
                console.error('更新系所失敗:', error);
                // 可以添加錯誤提示
            }
        },
        deleteDepartment(department) {
            this.deletingDepartment = { ...department };
            this.deleteConfirmDialog = true;
        },
        cancelDelete() {
            this.deleteConfirmDialog = false;
            setTimeout(() => {
                this.deletingDepartment = null;
            }, 300);
        },
        async confirmDelete() {
            if (!this.deletingDepartment) return;
            
            try {
                await DepartmentApiService.deleteDepartment(this.deletingDepartment._id);
                await this.fetchDepartments();
                this.deleteConfirmDialog = false;
                setTimeout(() => {
                    this.deletingDepartment = null;
                }, 300);
            } catch (error) {
                console.error('刪除系所失敗:', error);
                // 可以添加錯誤提示
            }
        }
    }
}
</script>

<style scoped>
.v-data-table ::v-deep th {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .v-data-table ::v-deep td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .v-icon {
    cursor: pointer;
  }
  
  .v-icon:hover {
    opacity: 0.7;
  }
  </style> 